module.exports = __webpack_public_path__ + "static/media/collection-bird-01.329cf9bf.png";